
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from 'react-router-dom';

const PricingSection = () => {
  const plans = [
    {
      name: "Reader Basic",
      price: "$4.99",
      description: "Perfect for casual news readers",
      features: [
        "Access to 5 journalist subscriptions",
        "Basic recommendation algorithm",
        "Comment on articles",
        "Mobile app access"
      ],
      buttonText: "Get Started",
      popular: false
    },
    {
      name: "Reader Premium",
      price: "$9.99",
      description: "Our most popular plan",
      features: [
        "Unlimited journalist subscriptions",
        "Advanced AI recommendations",
        "Early access to new features",
        "Ad-free reading experience",
        "Support your favorite writers"
      ],
      buttonText: "Subscribe Now",
      popular: true
    },
    {
      name: "Journalist Pro",
      price: "$14.99",
      description: "For professional writers",
      features: [
        "Publishing platform access",
        "90% revenue share",
        "Analytics dashboard",
        "Monetization tools",
        "Direct reader engagement",
        "AI writing assistant"
      ],
      buttonText: "Start Publishing",
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-directpress-blue mb-4">Simple Pricing</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose the plan that works for you, whether you're a reader or a journalist.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <Card key={index} className={`relative ${plan.popular ? 'border-directpress-orange shadow-lg' : 'border-gray-200'}`}>
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-directpress-orange text-white px-3 py-1 text-xs uppercase font-semibold rounded-bl-lg rounded-tr-lg">
                  Popular
                </div>
              )}
              <CardHeader>
                <CardTitle className="text-directpress-blue">{plan.name}</CardTitle>
                <CardDescription>{plan.description}</CardDescription>
                <div className="mt-4">
                  <span className="text-3xl font-bold text-directpress-blue">{plan.price}</span>
                  <span className="text-gray-500 ml-1">/month</span>
                </div>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <Check className="h-5 w-5 text-directpress-orange shrink-0 mr-2 mt-0.5" />
                      <span className="text-gray-600 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
              <CardFooter>
                <Button 
                  className={`w-full ${plan.popular ? 'bg-directpress-orange hover:bg-orange-600' : 'bg-directpress-blue hover:bg-blue-900'}`}
                  asChild
                >
                  <Link to="/subscription">{plan.buttonText}</Link>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Need a custom solution for your publication or organization?
          </p>
          <Button variant="outline" className="border-directpress-blue text-directpress-blue hover:bg-directpress-blue hover:text-white">
            Contact Sales
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
